// extracted by mini-css-extract-plugin
module.exports = {"Texto":"EntradaDeTexto_Texto__1uoYS"};